import {
  Calendar,
  Heading,
  Button as AriaButton,
  CalendarGrid,
  CalendarGridHeader,
  CalendarHeaderCell,
  CalendarGridBody,
  DateValue,
  CalendarCell,
} from 'react-aria-components';

import { parseDate, getLocalTimeZone } from '@internationalized/date';

import { formatDate } from '@/logics/date/date';
import { DetailedAttendanceReservation } from '@/types/attendanceReservation';

type Props = {
  reservations: DetailedAttendanceReservation[];
  setSelectedDate: (date: DateValue) => void;
  setFocusedDate: (date: DateValue) => void;
};

const MobileMonthlyCalendar = ({ reservations, setSelectedDate, setFocusedDate }: Props) => {
  const renderBody = (date: DateValue) => {
    // 予約一覧に該当日の予約があるかどうか
    const calendarDate = parseDate(date.toString());
    const res = reservations.find((res) => res.date === formatDate(date.toDate('Asia/Tokyo')));
    return (
      <CalendarCell
        date={calendarDate}
        className="relative h-10 bg-white"
      >
        {({ formattedDate, isSelected, isOutsideMonth }) => (
          <div
            className={`absolute inset-0 ${res && 'rounded-32 bg-green-200'} ${isSelected ? 'bg-blue-100' : ''} ${isOutsideMonth ? 'opacity-50' : ''}`}
          >
            <span
              className={`text-s flex h-full items-center justify-center text-center ${isOutsideMonth ? 'text-gray-400' : ''} ${date.toDate(getLocalTimeZone()).getDay() === 0 ? 'text-red-600' : ''} ${date.toDate(getLocalTimeZone()).getDay() === 6 ? 'text-blue-600' : ''}`}
            >
              {formattedDate}
            </span>
          </div>
        )}
      </CalendarCell>
    );
  };
  return (
    <Calendar
      className="rounded-md bg-gray-100 px-2 py-4"
      onChange={setSelectedDate}
      onFocusChange={setFocusedDate}
      aria-label="カレンダー"
    >
      <header className="flex justify-between">
        <Heading className="p-2 text-lg font-bold" />
        <div className="flex space-x-4">
          <AriaButton
            slot="previous"
            className="rounded-full p-2 hover:bg-gray-100"
          >
            <PreviousIcon />
          </AriaButton>
          <AriaButton
            slot="next"
            className="rounded-full p-2 hover:bg-gray-100"
          >
            <NextIcon />
          </AriaButton>
        </div>
      </header>
      <CalendarGrid className="w-full">
        <CalendarGridHeader>
          {(day) => (
            <CalendarHeaderCell
              className={`border-r border-gray-100 bg-white py-2 ${day === '日' ? 'text-red-600' : day === '土' ? 'text-blue-600' : 'text-[#969696]'}`}
            >
              {day}
            </CalendarHeaderCell>
          )}
        </CalendarGridHeader>
        <CalendarGridBody>{renderBody}</CalendarGridBody>
      </CalendarGrid>
    </Calendar>
  );
};

export default MobileMonthlyCalendar;

const PreviousIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91 1.91L6.5 0.5L0.5 6.5L6.5 12.5L7.91 11.09L3.33 6.5L7.91 1.91Z"
        fill="black"
      />
    </svg>
  );
};

const NextIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50009 0.5L0.0900879 1.91L4.67009 6.5L0.0900879 11.09L1.50009 12.5L7.50009 6.5L1.50009 0.5Z"
        fill="black"
      />
    </svg>
  );
};
